import Bugsnag from "@bugsnag/js";
import axiosInstance from "../../axiosInstance";
import URL from "../../urls";

import { SAVE_TWA_AI_UI_EVENTS, UPDATE_TWA_AI_UI_EVENT } from "./types";

export const saveTwaAIUIEvents = payload => ({
  type: SAVE_TWA_AI_UI_EVENTS,
  payload,
});

export const updateTwaAIUIEvent = eventType => ({
  type: UPDATE_TWA_AI_UI_EVENT,
  payload: eventType,
});

export const fetchTwaAIUIEvents = () => async (dispatch, getState) => {
  try {
    const { loaded } = getState().twaAI || {};

    if (loaded) {
      return;
    }

    const res = await axiosInstance.get(URL.twaAINudges);

    dispatch(saveTwaAIUIEvents(res?.data?.data || []));
  } catch (err) {
    Bugsnag.notify(err);
  }
};

export const markTwaAIEventShown = eventType => async dispatch => {
  try {
    await axiosInstance.patch(URL.twaAINudges, {
      event_type: eventType,
    });

    dispatch(updateTwaAIUIEvent(eventType));
  } catch (err) {
    Bugsnag.notify(err);
  }
};
